import { render } from "./simple.vue?vue&type=template&id=308adfa0&scoped=true"
import script from "./simple.vue?vue&type=script&lang=js"
export * from "./simple.vue?vue&type=script&lang=js"

import "./simple.vue?vue&type=style&index=0&id=308adfa0&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308adfa0"]])

export default __exports__